import styled from "styled-components";


export const ContainerFooter = styled.footer`
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex-wrap: nowrap;
    background: transparent;
    border-radius: 0;
    box-shadow: none;
    border-top: 0;
    align-items: center;
    padding: 20px 0;
    margin-bottom: 10px;
    border-top: 1px solid #e5e5e5;
    border-bottom: 1px solid #e5e5e5;
`

export const LabelFooter = styled.label`
    display: flex;

    color: #8c8c8c;
    font-size: 0.75rem;
    line-height: 13px;
    text-align: left;
    padding-right: 30px;

    @media(max-width:768px) {
       flex-direction: column;
    }  
`